const isNumber: (c: string) => boolean = (char: string) => !isNaN(parseInt(char, 10))

export const truncateFloatsOnString: (s: string, precision?: number) => string = (str, precision = 3) => {
  str = typeof str === 'string' ? str : JSON.stringify(str) || ``
  let newStr = ''
  let isOnNumber = false
  for (let i: number = 0; i < str.length; i++) {
    let char = str.charAt(i)
    if (isOnNumber && char === '.') {
      newStr += char
      const sumIfGood = (decimalsCount: number, j: number) => {
        if ((decimalsCount === (j)) && isNumber(str.charAt?.(i + j) || '')) {
          newStr += str.charAt?.(i + j)
          decimalsCount++
        }
        return decimalsCount
      }
      let decimalsCount = sumIfGood(1, 1)
      for (let decimalsSumming = 2; decimalsSumming < precision + 1; decimalsSumming++) {
        decimalsCount = sumIfGood(decimalsCount, decimalsSumming)
      }

      i += decimalsCount
      while (decimalsCount > precision && isNumber(str?.charAt?.(i))) {
        i++
      }
    } else if (isNumber(char)) {
      isOnNumber = true
    } else {
      isOnNumber = false
    }
    newStr += str.charAt(i)
  }
  return newStr
}
